import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.iterator";
import _classCallCheck from "/Users/dfravel/Projects/degreedata-wp/wp-content/plugins/dd-search/vue/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/dfravel/Projects/degreedata-wp/wp-content/plugins/dd-search/vue/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/dfravel/Projects/degreedata-wp/wp-content/plugins/dd-search/vue/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/dfravel/Projects/degreedata-wp/wp-content/plugins/dd-search/vue/node_modules/@babel/runtime/helpers/esm/inherits";
// Extensions
import { Service } from '../service'; // Utilities

import { mergeDeep } from '../../util/helpers'; // Presets

import presets from './presets';
export var Icons =
/*#__PURE__*/
function (_Service) {
  _inherits(Icons, _Service);

  function Icons(preset) {
    var _this;

    _classCallCheck(this, Icons);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Icons).call(this));
    var _preset$Icons$propert = preset[Icons.property],
        iconfont = _preset$Icons$propert.iconfont,
        values = _preset$Icons$propert.values;
    _this.iconfont = iconfont;
    _this.values = mergeDeep(presets[iconfont], values);
    return _this;
  }

  return Icons;
}(Service);
Icons.property = 'icons';